module.exports = __webpack_public_path__ + "static/media/applied.da192d85.svg";